import React from 'react';
import { FiInfo } from 'react-icons/fi';

interface InfoIconProps {
  tooltipText: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ tooltipText }) => {
  return (
    <div className="relative inline-flex items-center group cursor-help">
      <FiInfo className="w-4 h-4 text-black transition-colors duration-200" />
      <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max max-w-xs px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50 shadow-lg">
        {tooltipText}
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>
    </div>
  );
};

export default InfoIcon;